import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { cmsApi } from "@innovate/cms-admin-ui";

export function LoginPage() {
  const queryClient = useQueryClient();
  const login = useMutation({
    mutationFn: (values: { username: string; password: string }) =>
      cmsApi.login(values.username, values.password),
    onSuccess: (user) => queryClient.setQueryData(["me"], user),
  });
  return (
    <div className="cms-login">
      <Card className="cms-login-card">
        <Typography.Title level={3} style={{ marginBottom: 8 }}>INNOVATE CMS</Typography.Title>
        <Typography.Paragraph type="secondary" style={{ marginBottom: 28 }}>登录后维护官网首页、SEO 与访客数据。</Typography.Paragraph>
        {login.error ? <Alert type="error" showIcon message={login.error.message} style={{ marginBottom: 18 }} /> : null}
        <Form
          layout="vertical"
          size="large"
          requiredMark={false}
          initialValues={{ username: "admin" }}
          onFinish={(values) => login.mutate(values)}
        >
          <Form.Item name="username" label="账号" rules={[{ required: true, message: "请输入账号" }]}>
            <Input prefix={<UserOutlined />} autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: "请输入密码" }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={login.isPending}>登录</Button>
        </Form>
      </Card>
    </div>
  );
}
